import React from "react";
import PremiumCheckoutLander from "./PremiumCheckoutLander";

const PremiumMonthlyLander: React.FC = () => (
    <PremiumCheckoutLander plan="monthly" />
);

export default PremiumMonthlyLander;
